import { createElementBlock as s, openBlock as l, createElementVNode as n, defineComponent as R, mergeModels as S, useModel as F, ref as k, computed as w, onMounted as j, createCommentVNode as C, createBlock as c, normalizeClass as z, renderSlot as A, Fragment as u, createVNode as p, createTextVNode as V, toDisplayString as v, capitalize as P, unref as r, withCtx as N, renderList as y, nextTick as Q } from "vue";
import { _ as D } from "./UiFlagIcon.vue_vue_type_script_setup_true_lang-kwJ9_1c-.js";
/* empty css                                                    */
import { _ as L } from "./UiLanguageButton.vue_vue_type_script_setup_true_lang-Doe8M7Tx.js";
import { decodeSearchQuery as q } from "../components/UiLanguages/decode.js";
import "./vue3-lottie.es-BQlzj7s3.js";
import "./style-R_nxVIjQ.js";
import { _ as G } from "./UiIcon.vue_vue_type_script_setup_true_lang-BEUNoCyM.js";
/* empty css                                                */
/* empty css                                                         */
/* empty css                                                    */
import "./useDatePicker-DAFR8Jnp.js";
import { config as b } from "../config/index.js";
/* empty css                                                           */
/* empty css                                                       */
import { _ as J } from "./UiDrawer.vue_vue_type_script_setup_true_lang-Vs6J1MR6.js";
/* empty css                                                  */
/* empty css                                                    */
/* empty css                                                    */
import { _ as K } from "./UiInput.vue_vue_type_script_setup_true_lang-BDfkjA8a.js";
import { useBreakpoints as O } from "../composables/useBreakpoints.js";
/* empty css                                                  */
/* empty css                                                      */
import "vue-router";
/* empty css                                                */
import { _ as W } from "./UiModal.vue_vue_type_script_setup_true_lang-BfMdbJVa.js";
/* empty css                                                   */
/* empty css                                                 */
/* empty css                                                      */
/* empty css                                                        */
/* empty css                                                    */
/* empty css                                                */
/* empty css                                                    */
/* empty css                                                               */
/* empty css                                                    */
const X = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
};
function Y(g, f) {
  return l(), s("svg", X, f[0] || (f[0] = [
    n("path", {
      stroke: "#717173",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "m15 15 4 4M9 17A8 8 0 1 0 9 1a8 8 0 0 0 0 16"
    }, null, -1)
  ]));
}
const Z = { render: Y }, x = { class: "ui-languages" }, ee = ["disabled"], ae = { class: "ui-languages--modal" }, oe = { class: "ui-languages--modal__search" }, le = {
  key: 0,
  class: "ui-languages__favourites"
}, se = { key: 1 }, te = {
  key: 2,
  class: "ui-languages--modal__empty"
}, re = { class: "ui-languages--drawer__wrapper" }, ie = { class: "ui-languages--drawer__header" }, ne = { class: "ui-languages--drawer__items" }, ue = {
  key: 0,
  class: "ui-languages__favourites"
}, Ge = /* @__PURE__ */ R({
  __name: "UiLanguages",
  props: /* @__PURE__ */ S({
    locales: {},
    disabled: { type: Boolean },
    minNumbersLocalesDisplayFavorites: { default: 10 },
    forHeader: { type: Boolean, default: !1 },
    isHidden: { type: Boolean }
  }, {
    modelValue: { default: null },
    modelModifiers: {},
    "is-show": { type: Boolean, default: !1 },
    "is-showModifiers": {}
  }),
  emits: /* @__PURE__ */ S(["change"], ["update:modelValue", "update:is-show"]),
  setup(g, { emit: f }) {
    const E = f, B = g, t = F(g, "modelValue"), d = F(g, "is-show"), { isMobile: U } = O(), i = k(""), H = k(), $ = k([]), h = w(() => [
      { id: 2, name: "English", isoCode: "en", nativeName: "English" },
      ...$.value,
      t.value
    ].filter((e, a, o) => a === o.findIndex((T) => T.isoCode === e.isoCode))), M = w(() => B.locales.toSorted((e, a) => e.name.localeCompare(a.name))), m = w(() => {
      if (i.value) {
        const e = q(i.value);
        return M.value.filter(
          (a) => a.name.toLocaleLowerCase().includes(i.value.toLocaleLowerCase()) || a.nativeName?.toLocaleLowerCase().includes(e.toLocaleLowerCase()) || a.nativeName?.toLocaleLowerCase().includes(i.value.toLocaleLowerCase())
        );
      } else
        return M.value;
    });
    function _(e) {
      t.value = e, d.value = !1, i.value = "", E("change", e);
    }
    function I() {
      d.value = !0, Q(() => {
        H.value?.focus();
      });
    }
    return j(() => {
      const e = navigator.languages.slice(0, 2).map((a) => a.split("-")[0]);
      $.value = B.locales.filter(({ isoCode: a }) => e.includes(a));
    }), (e, a) => (l(), s("div", x, [
      e.isHidden ? C("", !0) : (l(), s("button", {
        key: 0,
        disabled: e.disabled,
        class: z([{ "for-header": e.forHeader }, "ui-languages--trigger"]),
        onClick: I
      }, [
        A(e.$slots, "trigger", { locale: t.value }, () => [
          e.forHeader ? (l(), s(u, { key: 0 }, [
            p(D, {
              isoCode: t.value?.isoCode ?? "",
              "is-small": ""
            }, null, 8, ["isoCode"]),
            V(" " + v(P(t.value?.isoCode ?? "")), 1)
          ], 64)) : (l(), s(u, { key: 1 }, [
            p(D, {
              isoCode: t.value?.isoCode ?? ""
            }, null, 8, ["isoCode"]),
            V(" " + v(t.value?.name) + " ", 1),
            t.value?.nativeName ? (l(), s(u, { key: 0 }, [
              V("(" + v(t.value?.nativeName) + ")", 1)
            ], 64)) : C("", !0)
          ], 64))
        ])
      ], 10, ee)),
      r(U) ? (l(), c(r(J), {
        key: 2,
        class: "ui-languages--drawer",
        direction: "btt",
        modelValue: d.value,
        "onUpdate:modelValue": a[3] || (a[3] = (o) => d.value = o)
      }, {
        default: N(() => [
          n("div", re, [
            n("div", ie, [
              n("p", null, v(r(b).uiLanguages.translations.changeLanguage), 1),
              p(r(G), {
                name: "close",
                type: "400",
                size: "lg"
              })
            ]),
            n("div", ne, [
              h.value?.length && m.value.length >= e.minNumbersLocalesDisplayFavorites ? (l(), s("div", ue, [
                (l(!0), s(u, null, y(h.value, (o) => (l(), c(L, {
                  key: o.id,
                  locale: o,
                  onChange: _,
                  selected: t.value,
                  "for-header": e.forHeader
                }, null, 8, ["locale", "selected", "for-header"]))), 128))
              ])) : C("", !0),
              (l(!0), s(u, null, y(m.value, (o) => (l(), c(L, {
                key: o.id,
                locale: o,
                onChange: _,
                selected: t.value,
                "for-header": e.forHeader
              }, null, 8, ["locale", "selected", "for-header"]))), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])) : (l(), c(r(W), {
        key: 1,
        onClose: a[1] || (a[1] = (o) => i.value = ""),
        modelValue: d.value,
        "onUpdate:modelValue": a[2] || (a[2] = (o) => d.value = o),
        isShowBtnClose: !1,
        popperClass: "transparent-bg"
      }, {
        default: N(() => [
          n("div", ae, [
            n("div", oe, [
              p(r(K), {
                ref_key: "inputRef",
                ref: H,
                autofocus: "",
                size: "sm",
                modelValue: i.value,
                "onUpdate:modelValue": a[0] || (a[0] = (o) => i.value = o),
                placeholder: r(b).uiLanguages.translations.searchInputPlaceholder
              }, {
                prepend: N(() => [
                  p(r(Z))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            n("div", {
              class: z(["ui-languages--modal__items", { "is-empty": !m.value.length }])
            }, [
              h.value?.length && m.value.length >= e.minNumbersLocalesDisplayFavorites ? (l(), s("div", le, [
                (l(!0), s(u, null, y(h.value, (o) => (l(), c(L, {
                  key: o.id,
                  locale: o,
                  onChange: _,
                  selected: t.value,
                  "for-header": e.forHeader
                }, null, 8, ["locale", "selected", "for-header"]))), 128))
              ])) : C("", !0),
              m.value.length ? (l(), s("div", se, [
                (l(!0), s(u, null, y(m.value, (o) => (l(), c(L, {
                  key: o.id,
                  locale: o,
                  onChange: _,
                  selected: t.value,
                  "for-header": e.forHeader
                }, null, 8, ["locale", "selected", "for-header"]))), 128))
              ])) : (l(), s("div", te, v(r(b).uiLanguages.translations.modalSearchNotFound), 1))
            ], 2)
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]))
    ]));
  }
});
export {
  Ge as _
};
